import React, { useState, useEffect } from 'react'
import Header from '../Utilities/Header'
import Footer from '../Utilities/Footer'
import { useParams, Link } from 'react-router-dom';
import { fetchBlogBySlug, formatBlogDate } from '../Utilities/api';
import BCategory from '../Utilities/BCategory';
import LatestPosts from '../Utilities/LatestPosts';
import { Helmet } from 'react-helmet'

const BlogDetails = () => {

    const { slug } = useParams();
    const [blogs, Setblogs] = useState({});

    useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });

        fetchBlogBySlug(slug)
            .then(data => Setblogs(data || {}))
            .catch(err => console.error('Failed to fetch blog:', err));
    }, [slug]);


    const seo = blogs.seo || {};
    const pageUrl = seo.canonicalUrl || "https://www.wisefinserv.com/blog/" + slug;
    const metaTitle = seo.metaTitle || blogs.title;
    const metaDescription = seo.metaDescription || blogs.shortDescription;
    const ogTitle = seo.ogTitle || metaTitle;
    const ogDescription = seo.ogDescription || metaDescription;
    const ogImage = seo.ogImage?.url || blogs.image?.url;

    return (
        <div>
            <Header />
            <Helmet>
                <meta charSet="utf-8" />
                {metaTitle && <title>{metaTitle}</title>}
                {metaDescription && <meta name="description" content={metaDescription} />}
                {seo.metaKeywords && <meta name="keywords" content={seo.metaKeywords} />}
                <meta name="robots" content={seo.robots || "index,follow"} />
                <link rel="canonical" href={pageUrl} />

                <meta property="og:type" content="article" />
                {ogTitle && <meta property="og:title" content={ogTitle} />}
                {ogDescription && <meta property="og:description" content={ogDescription} />}
                {ogImage && <meta property="og:image" content={ogImage} />}
                <meta property="og:url" content={pageUrl} />

                <meta name="twitter:card" content="summary_large_image" />
                {ogTitle && <meta name="twitter:title" content={ogTitle} />}
                {ogDescription && <meta name="twitter:description" content={ogDescription} />}
                {ogImage && <meta name="twitter:image" content={ogImage} />}

                {seo.schemaMarkup && (
                    <script type="application/ld+json">{seo.schemaMarkup}</script>
                )}
            </Helmet>

            <div className="blog">
                <div className="blog-body">
                    <div className="blog-body-content">
                        <div className="blog-card blog-details">
                            {/* <img src={blogs.image?.url} alt={blogs.title} class="blog-inner-image"  /> */}
                            <div className="blog-card-text">
                                <span className='date'>{formatBlogDate(blogs)}</span>

                                <h1>{blogs.title}</h1>
                                <div dangerouslySetInnerHTML={{ __html: blogs.content }}></div>
                            </div>
                        </div>
                    </div>

                    <div className="blog-body-text">
                        <div className="blog-body-categories">
                            <h4>Categories</h4>
                            <BCategory />
                        </div>
                        <div className="blog-body-categories">
                            <h4>Latest Posts</h4>
                            <LatestPosts />
                        </div>
                    </div>
                </div>
            </div>
            {/* <div className="blog-body">
                <div className="blog-body-content">
                    <div className="blog-details-img">
                        <img src={blogs.Image} alt="" />
                        <span></span>
                    </div>
                    <div className="blog-details-text">
                        <h1>{blogs.Title}</h1>
                        <div dangerouslySetInnerHTML={{ __html: blogs.Body }}></div>
                    </div>
                </div>

                <div className="blog-body-text">
                    <div className="blog-body-categories">
                        <h4>Categories</h4>
                        <BCategory />
                    </div>
                    <div className="blog-body-categories">
                        <h4>Latest Posts</h4>
                        <LatestPosts />
                    </div>
                </div>
            </div> */}
            {/* <div className="blog-details">
                <div className="blog-details-img">
                    <img src={blogs.Image} alt="" />
                    <span></span>
                </div>
                <div className="blog-details-text">
                    <h1>{blogs.Title}</h1>
                    <div dangerouslySetInnerHTML={{ __html: blogs.Body }}></div>
                </div>
            </div > */}
            <Footer />
        </div >
    )
}

export default BlogDetails
